export default {
  it: {
    message: {
      title: 'Benvenuto su TOK.tv web player',
    },
  },
  en: {
    message: {
      title: 'Welcome to TOK.tv web player',
    },
  },
};



// WEBPACK FOOTER //
// ./src/assets/i18n/i18n.js